import React, { useEffect, useState } from "react";
import "./Otp.css";
import {validateforotp} from '../../Utils/validate';
import { Form } from 'react-bootstrap';
import { gettoastwarning,gettoastsuccess } from '../../Utils/Common';
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';


const Otp = () => {
   const [loading,setLoading] = useState(false);

  const [errors,setErrors] = useState({});

  const [otp, setOtp] = useState(Array(6).fill(""));

  //const [email,setEmail] = useState();

  const handleInput = (e, index) => {
    const val = e.target.value.replace(/\D/, "");
    const newOtp = [...otp];

    if (e.key === "Backspace") {
      newOtp[index] = "";
      if (!otp[index] && index > 0) document.getElementById(`otp-${index - 1}`).focus();
    } else if (val) {
      newOtp[index] = val;
      if (index < otp.length - 1) document.getElementById(`otp-${index + 1}`).focus();
    }

    setOtp(newOtp);
  };

  useEffect(() => {
    document.title = `Otp | bluefaucet`;
    document.getElementById('bodywrap').className='login';

   if (localStorage.getItem('email') !== null) {
    //setEmail(localStorage.getItem('email'));
  }else
  {   
    window.location.href = "/forgot-password";
  }
  localStorage.removeItem("otp");

  },[]); 
 
//Start OTP check
const handleSubmit = (event) => {
  event.preventDefault();
  const validationErrors = validateforotp(otp);
  const noErrors = Object.keys(validationErrors).length === 0;
  setErrors(validationErrors);
  if(noErrors){
    setLoading(true);
    var ot='';
    otp.forEach((item, index) => {
      ot+=item;
    })

    let formData = new FormData();
    formData.append('code', ot);
    API.post('backoffice_code_check', formData)
      .then(response => {
        setLoading(false); 
      if(response.data.status === 0){
         gettoastwarning(response.data.message,'');
      }else{
        localStorage.setItem("otp", otp);
        gettoastsuccess(response.data.message,'/new-password');
      }                  
    }).catch(error => {
       setLoading(false);
        gettoastwarning('Something went wrong. Please try again later.','');
    });  
  }
}

  return (
    <>
      <div className="container d-flex align-items-center justify-content-center mains">
        <div className="row w-100 flex-column flex-md-row justify-content-center">
          <div className="col-md-12 d-flex flex-column flex-md-row p-0 vach">
            {/* Right Section - Brand Info (Shown First on Mobile) */}
            <div className="col-md-5 right-section d-flex flex-column justify-content-center align-items-center order-md-2">
              <div className="right-logo">
                <img
                  src="/assests/images/bluefaucet-logo.png"
                  alt="BlueFaucet Logo"
                  className="img-fluid"
                />
              </div>
              <p>
                Welcome to BlueFaucet
                <br />
                Where we take care of your business.
              </p>
              <div className="position-relative hello w-100">
                <div className="de-1">
                  <img
                    src="/assests/images/round.png"
                    alt="Decor 1"
                    className="img-fluid"
                  />
                </div>
                <div className="de-2">
                  <img
                    src="/assests/images/trikon.png"
                    alt="Decor 2"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>

            {/* Left Section - Sign In Form */}
            <div className="col-md-7 left-section forgu d-flex flex-column justify-content-center">
              <h2>Otp</h2>
              <form method="post" onSubmit={handleSubmit} enctype="multipart/form-data">
                <Form.Group className="mb-4">
                <div className="input-group mb-0">
                  <div className="d-flex gap-2">
                    {otp.map((digit, i) => (
                      <input
                        key={i}
                        id={`otp-${i}`}
                        type="text"
                        className="form-control oma text-center"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleInput(e, i)}
                        onKeyDown={(e) => handleInput(e, i)}
                      />
                    ))}
                  </div>
                </div>
                {errors.otp && (<p className="text-danger text-start mb-0">{errors.otp}</p>)}
                </Form.Group>
                <button type="submit" className="btn w-100">
                  SUBMIT
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {loading && (
           <div className="loadingClass">
            <img src={loader} alt="loader"/>
          </div>
           )} 
    </>
  );
};

export default Otp;
